import { VERIFF_STATUS } from '@/app/account/components/verification/components/VerificationLevel_2/VerificationLevel_2';
import { useUser } from '@/store';
import React, { useMemo } from 'react';

const useUserVerificationLevels = () => {
	const user = useUser();

	const isEmail_verified = useMemo(() => {
		if (user?.emailVerified) {
			return user.emailVerified;
		} else {
			return false;
		}
	}, [user]);

	const isVerified_level_1 = useMemo(() => {
		if (user?.moreDetails?.personalDetails) {
			return true;
		} else {
			return false;
		}
	}, [user]);
	const isVerified_level_2 = useMemo(() => {
		if (user?.veriffStatus === VERIFF_STATUS.APPROVED) {
			return true;
		} else {
			return false;
		}
	}, [user]);

	const showVerificationStepsModal = useMemo(() => {
		if (!isEmail_verified || !isVerified_level_1) {
			return true;
		}
		return false;
	}, [isEmail_verified, isVerified_level_1]);

	const isVerified_level_3 = false;
	return {
		isVerified_level_1,
		isVerified_level_2,
		isVerified_level_3,
		isEmail_verified,
		showVerificationStepsModal,
	};
};

export default useUserVerificationLevels;
